/* Le Tonneau Gourmand — interactions du thème (vanilla, sans dépendance) */
(function () {
  'use strict';

  /* Menu mobile ---------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.querySelector('[data-menu]');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* Galerie produit ------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    if (main) {
      main.src = thumb.dataset.full;
      main.alt = thumb.dataset.alt || main.alt;
    }
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (el) {
      el.setAttribute('aria-pressed', el === thumb ? 'true' : 'false');
    });
  });

  /* Sélection de variante ------------------------------------------------ */
  function initVariantPicker(root) {
    var data = root.querySelector('[data-variant-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var input = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-variant-price]');
    var compareEl = root.querySelector('[data-variant-compare]');
    var submit = root.querySelector('[data-add-to-cart]');
    var availability = root.querySelector('[data-variant-availability]');
    var moneyFormat = root.dataset.moneyFormat || '{{amount_with_comma_separator}} €';

    function formatMoney(cents) {
      var value = (cents / 100).toLocaleString('fr-FR', {
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      });
      return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
    }

    function select(variantId) {
      var variant = variants.filter(function (v) { return String(v.id) === String(variantId); })[0];
      if (!variant) return;
      if (input) input.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.dataset.labelAvailable : submit.dataset.labelSoldOut;
      }
      if (availability) {
        availability.textContent = variant.available ? availability.dataset.inStock : availability.dataset.outOfStock;
      }
      root.querySelectorAll('[data-variant-pill]').forEach(function (pill) {
        pill.setAttribute('aria-pressed', String(pill.dataset.variantPill) === String(variant.id) ? 'true' : 'false');
      });
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      var featured = root.querySelector('[data-gallery-main]');
      if (featured && variant.featured_image) featured.src = variant.featured_image;
    }

    root.querySelectorAll('[data-variant-pill]').forEach(function (pill) {
      pill.addEventListener('click', function () { select(pill.dataset.variantPill); });
    });

    var params = new URLSearchParams(window.location.search);
    if (params.get('variant')) select(params.get('variant'));
  }

  document.querySelectorAll('[data-variant-picker]').forEach(initVariantPicker);

  /* Quantité ------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-change]');
    if (!button) return;
    var wrapper = button.closest('[data-qty]');
    var input = wrapper && wrapper.querySelector('input');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(button.dataset.qtyChange, 10);
    input.value = Math.max(parseInt(input.min || '1', 10), next);
    if (input.dataset.autoSubmit) input.form.submit();
  });

  /* Modale de prise de rendez-vous ---------------------------------------- */
  function openRdvModal(modal) {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('rdv-modal-open');
    var firstField = modal.querySelector('input, textarea, select');
    if (firstField) firstField.focus();
  }

  function closeRdvModal(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('rdv-modal-open');
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-rdv-open]');
    if (opener) {
      var modal = document.getElementById(opener.dataset.rdvOpen);
      if (modal) openRdvModal(modal);
      return;
    }
    var closer = event.target.closest('[data-rdv-close]');
    if (closer) {
      var modalToClose = closer.closest('[data-rdv-modal]');
      if (modalToClose) closeRdvModal(modalToClose);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openModal = document.querySelector('[data-rdv-modal].is-open');
    if (openModal) closeRdvModal(openModal);
  });

  /* Rouvre la modale après un envoi de formulaire (retour avec erreurs/succès) */
  document.querySelectorAll('[data-rdv-modal] .form-status').forEach(function (status) {
    var modal = status.closest('[data-rdv-modal]');
    if (modal) openRdvModal(modal);
  });

  /* Bandeau cookies ------------------------------------------------------ */
  var banner = document.querySelector('[data-cookie-banner]');
  if (banner) {
    var KEY = 'ltg-cookie-consent';
    if (!localStorage.getItem(KEY)) banner.classList.add('is-visible');
    banner.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-cookie-choice]');
      if (!choice) return;
      localStorage.setItem(KEY, choice.dataset.cookieChoice);
      banner.classList.remove('is-visible');
    });
  }

  /* Recherche de recettes ------------------------------------------------ */
  var search = document.querySelector('[data-recipe-search]');
  if (search) {
    search.addEventListener('input', function () {
      var term = search.value.trim().toLowerCase();
      document.querySelectorAll('[data-recipe-item]').forEach(function (item) {
        var haystack = item.dataset.recipeItem.toLowerCase();
        item.style.display = !term || haystack.indexOf(term) !== -1 ? '' : 'none';
      });
    });
  }
})();
